import { Area } from "./Area";
import { DateTime_fromTransferable, DateTime_toTransferable } from "./DateTime";
export function WfsRequest_toTransferable(req) {
    return {
        ...req,
        area: req.area.toTransferable(),
        datetime: DateTime_toTransferable(req.datetime),
    };
}
export function WfsRequest_fromTransferable(req) {
    return {
        ...req,
        requestType: req.requestType,
        area: Area.fromTransferable(req.area),
        datetime: DateTime_fromTransferable(req.datetime),
        boundingBoxLimit: req.boundingBoxLimit ? Area.fromTransferable(req.boundingBoxLimit) : null,
    };
}
//# sourceMappingURL=WfsRequest.js.map